import classNames from "classnames";
import { memo } from "react";
import { RedoToggle } from "../arbiter-components/toggle/redo-toggle";
import { Flex } from "../flex";
import { useCompactSettings } from "./settings-density-context";
import { SettingsRowLabel, type SettingsRowBadge } from "./settings-row-label";
import * as css from "./settings-rows.module.css";

/** Row with a switch. */
export const SettingsToggleRow = memo(function SettingsToggleRow({
  title,
  description,
  detail,
  info,
  badge,
  value,
  setValue,
  disabled,
  indeterminate,
  semantic,
  testId,
}: {
  title: string;
  description?: string;
  /** Extra muted line under the description. */
  detail?: string;
  /** Longer help shown on an info icon next to the title. */
  info?: string;
  badge?: SettingsRowBadge;
  value: boolean;
  setValue(value: boolean): void;
  disabled?: string | boolean;
  /** Mixed state. The stored value stays a boolean. */
  indeterminate?: boolean;
  semantic?: boolean;
  testId?: string;
}) {
  const compact = useCompactSettings();
  return (
    <Flex
      align="center"
      gap={compact ? "xl" : "3xl"}
      justify="space-between"
      px={compact ? "none" : "2xl"}
      py={compact ? "md" : "xl"}
      w="full"
    >
      <Flex className={classNames(disabled && css.rowLabelDisabled)}>
        <SettingsRowLabel
          badge={badge}
          description={description}
          detail={detail}
          info={info}
          title={title}
        />
      </Flex>
      <RedoToggle
        aria-label={title}
        disabled={disabled}
        indeterminate={indeterminate}
        semantic={semantic}
        setValue={setValue}
        size="sm"
        testId={testId}
        value={value}
      />
    </Flex>
  );
});
